export default {
  'form.entityInfo': 'Информация о {{entity}}',
  'form.required': 'Поле {{field}} обязательно',
  'form.inputPlaceholder': 'Введите {{field}}',
  'form.selectPlaceholder': 'Выберите {{field}}',
  'form.invalidLayout': 'Несовместимая разметка',
  'form.cloneFrom': 'Клонировать из {{instance}}',
  'form.image': 'Изображение {{type}}',
  'form.image.filename': 'Имя изображения',
  'form.image.altText': 'Альтернативный текст',
  'form.fullName': 'Полное имя',
  'form.firstName': 'Имя',
  'form.lastName': 'Фамилия',
  'form.middleName': 'Отчество',
  'form.honorificName': 'Титул',
  'form.birthdate': 'Дата рождения',
  'form.genderIdentity': 'Гендерная идентичность',
  'form.entity': 'Сущность',
  'form.entityKey': 'Ключ сущности',
  'form.contentKey': 'Ключ контента',
  'form.upload': 'Загрузить',
  'form.selectFile': 'Выбрать файл',
  'form.uploadText': 'Кликните или перетащите файл в эту область для загрузки',
  'form.uploadHint':
    'Поддерживается одиночная или массовая загрузка. Строго запрещено загружать корпоративные данные или другие конфиденциальные файлы',
  'form.uploadTypeError': '{name} — недопустимый тип файла',
  'form.uploadDimsError':
    'Максимальный размер изображения (Ширина x Высота) {width}px x {height}px',
  'form.translate': 'Перевести ключи',
  'form.helper': 'Показать подсказку',
  'form.license': 'Лицензия',
  'form.license.type': 'Тип лицензии',
  'form.license.number': 'Номер лицензии',
  'form.licenses': 'Лицензии',
  'form.title': 'Название',
  'form.number': 'Номер',
  'form.description': 'Описание',
  'form.shortDescription': 'Краткое описание',
  'form.status': 'Статус',
  'form.tags': 'Теги',
  'form.target': 'Цель',
  'form.link': 'Ссылка',
  'form.logo': 'Логотип',
  'form.logos': 'Логотипы',
  'form.logo.primary': 'Основной логотип',
  'form.email.type': 'Тип email',
  'form.email': 'Email адрес',
  'form.emails': 'Email адреса',
  'form.countryCode': 'Код страны',
  'form.phone': 'Номер телефона',
  'form.phones': 'Номера телефонов',
  'form.phone.type': 'Тип устройства',
  'form.phone.businessType': 'Рабочий',
  'form.phone.ability': 'Тип телефона',
  'form.phone.extension': 'Доб.',
  'form.email.primary': 'Основной email',
  'form.email.primary.description':
    'будет использоваться для уведомлений по учётной записи и сброса пароля.',
  'form.private.helper':
    'Приватный {{type}} не может быть установлен как Публичный Основной {{type}} в системе',
  'form.billing.helper':
    'Приватный {{type}} не может быть установлен как Публичный Платёжный {{type}} в системе',
  'form.unverified.helper':
    'Неподтверждённый {{type}} не может быть установлен как Публичный Основной {{type}} в системе',
  'form.phone.primary': 'Основной номер телефона',
  'form.phone.primary.description':
    'будет использоваться для звонков по учётной записи.',
  'form.email.exists': 'Email уже существует',
  'form.phone.exists': 'Номер телефона уже существует',
  'form.preview': 'Предпросмотр',
  'form.documentUrl': 'URL документа',
  'form.imgUrl': 'URL изображения',
  'form.embedUrl': 'URL для встраивания',
  'form.ownerName': 'Имя владельца',
  'form.issueDate': 'Дата выдачи',
  'form.expirationDate': 'Дата окончания',
  'form.renewalDate': 'Дата продления',
  'form.createdBy': 'Создано',
  'form.updatedBy': 'Обновлено',
  'form.createdAt': 'Создано в',
  'form.lastUsed': 'Последнее использование',
  'form.updatedAt': 'Обновлено в',
  'form.invitedAt': 'Приглашено в',
  'form.today': 'Сегодня',
  'form.tomorrow': 'Завтра',
  'form.days': '{{count}} дней',
  'form.customize': 'Настроить',
  'form.noExpiration': 'Без ограничения',
  'form.nameHelp':
    'Ваш {{type}} может отображаться в WelcomeHome в местах вашего участия или упоминания.',
  'form.type.public': 'Публичный',
  'form.type.primary': 'Основной',
  'form.type.draft': 'Черновик',
  'form.type.private': 'Приватный',
  'form.type.minor': 'Второстепенный',
  'form.assets': 'Ресурсы ({{amount}})',
  'form.validation.min': '{{entity}} должен содержать минимум {min} символов',
  'form.metadata': 'Метаданные',
  'form.section': 'Раздел',
  'form.private': 'Приватный',
  'form.public': 'Публичный',
  'form.source': 'Источник',
  'form.switch.yes': 'Да',
  'form.switch.no': 'Нет',
  'form.phone.invalidPhone': 'Некорректный номер телефона',
  'form.phone.countryCode': 'Код страны',
  'form.approve': 'Одобрить',
  'form.toHide': 'Скрыть',
  'form.toShow': 'Показать',
  'form.confirm': 'Подтвердить',
  'form.name': 'Название {{entity}}',
  'form.type': 'Тип',
  'form.typeOf': 'Тип {{entity}}',
  'form.verify': 'Подтвердить {{type}}',
  'form.enterField': 'Введите {{type}} здесь',
  'form.tag.helper':
    'Добавьте ключевые слова для категоризации или идентификации функции',
  'form.metadata.helper':
    'Системная информация: кто создал или обновил этот элемент и когда',

  'form.credits.modal.title': 'Выдать кредиты',
  'form.credits.modal.ok': 'Выдать',
  'form.credits.tenant': 'Тенант',
  'form.credits.tenant.tooltip':
    'Тенант (организация), на кошелёк которого будут зачислены кредиты.',
  'form.credits.tenant.placeholder': 'Выберите тенанта',
  'form.credits.tenant.noTenants': 'Тенанты не найдены.',
  'form.credits.tenant.createLink': 'Создать тенанта',
  'form.credits.userId': 'ID пользователя',
  'form.credits.userId.tooltip':
    'Пользователь, которому начисляются кредиты. По умолчанию — ваш UID. Измените, чтобы зачислить другому пользователю.',
  'form.credits.userId.extra':
    'Предзаполнено вашим UID. Измените, чтобы выбрать другого получателя.',
  'form.credits.userId.placeholder': 'Firebase UID получателя',
  'form.credits.amount': 'Количество',
  'form.credits.amount.tooltip':
    'Количество кредитов для начисления. Должно быть положительным целым числом.',
  'form.credits.kind': 'Тип',
  'form.credits.kind.tooltip':
    'GRANT — добавляет кредиты; DEBIT — списывает; REFUND — возвращает ранее списанные кредиты.',
  'form.credits.kind.grant': 'GRANT — добавить кредиты',
  'form.credits.kind.debit': 'DEBIT — списать кредиты',
  'form.credits.kind.refund': 'REFUND — вернуть списанные кредиты',
  'form.credits.kind.adjustment': 'ADJUSTMENT — ручная корректировка баланса',
  'form.credits.referenceId': 'ID ссылки',
  'form.credits.referenceId.tooltip':
    'Внешний референс для трекинга — например, ID счёта, заказа или тикета поддержки.',
  'form.credits.referenceId.extra':
    'Укажите любой внешний ID (счёт, заказ, тикет).',
  'form.credits.referenceId.placeholder': 'напр. INV-2024-001',
  'form.credits.operation': 'Операция',

  'form.entitlements.operation': 'Операция',
  'form.entitlements.kind': 'Тип',
  'form.entitlements.costPerUnit': 'Стоимость / ед.',
  'form.entitlements.version': 'Версия',
  'form.entitlements.isActive': 'Активно',

  'form.subscription.monthlyCredits': 'Кредиты в месяц',
};
